import React from 'react';
import { X, Phone, MessageSquare, Mail, Calendar } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export default function AddSaleModal() {
  const {
    showAddSale, setShowAddSale,
    saleForm, setSaleForm,
    sales, setSales,
    editingSaleId, setEditingSaleId,
    showAddActivity, setShowAddActivity,
    activityForm, setActivityForm,
    logTouch,
  } = useAppContext();

  if (!showAddSale && !showAddActivity) return null;

  const isEditing = !!editingSaleId;

  // ── Add / Edit Sale Modal ──
  if (showAddSale) {
    return (
      <div className="modal-overlay" onClick={() => { setShowAddSale(false); setEditingSaleId(null); }}>
        <div className="modal-sheet" onClick={e => e.stopPropagation()}>
          <div className="modal-hdr">
            <h3>{isEditing ? 'Edit Sale' : 'Add Sale'}</h3>
            <button className="modal-x" onClick={() => { setShowAddSale(false); setEditingSaleId(null); }}>
              <X size={20}/>
            </button>
          </div>
          <form onSubmit={e => {
            e.preventDefault();
            if (isEditing) {
              // Update existing sale
              setSales(prev => prev.map(s => s.id === editingSaleId ? {
                ...s,
                customerName: saleForm.customerName,
                vehicle: saleForm.vehicle,
                condition: saleForm.condition,
                frontGross: Number(saleForm.frontGross) || 0,
                backGross: Number(saleForm.backGross) || 0,
                spiffs: Number(saleForm.spiffs) || 0,
                notes: saleForm.notes,
              } : s));
              setEditingSaleId(null);
            } else {
              // Add new sale
              const newSale = { 
                ...saleForm, 
                id: Date.now().toString(),
                frontGross: Number(saleForm.frontGross) || 0, 
                backGross: Number(saleForm.backGross) || 0, 
                spiffs: Number(saleForm.spiffs) || 0,
                soldDate: new Date().toISOString() 
              };
              setSales(prev => [...prev, newSale]);
            }
            setShowAddSale(false);
            setSaleForm({ customerName:'', vehicle:'', condition:'New', frontGross:0, backGross:0, spiffs:0, notes:'' });
          }} className="modal-form">
            {[['Customer Name','customerName','text'],['Vehicle','vehicle','text']].map(([lbl,k,t])=>(
              <div key={k} className="form-group">
                <label>{lbl}</label>
                <input type={t} required value={saleForm[k]} 
                onFocus={e => { if (e.target.value === '0') e.target.select(); }}
                onChange={e=>setSaleForm(f => ({...f,[k]:e.target.value}))}/>
              </div>
            ))}
            <div className="form-group">
              <label>Condition</label>
              <select value={saleForm.condition} onChange={e=>setSaleForm(f => ({...f,condition:e.target.value}))}>
                <option>New</option><option>Used</option>
              </select>
            </div>
            {[['Front Gross ($)','frontGross'],['Back Gross ($)','backGross'],['Spiffs ($)','spiffs']].map(([lbl,k])=>(
              <div key={k} className="form-group">
                <label>{lbl}</label>
                <input type="number" value={saleForm[k]} 
                onFocus={e => { if (e.target.value === '0') e.target.select(); }}
                onChange={e=>setSaleForm(f => ({...f,[k]:e.target.value === '' ? '' : e.target.value}))}/>
              </div>
            ))}
            <div className="form-group">
              <label>Notes</label>
              <textarea 
                value={saleForm.notes} 
                onChange={e=>setSaleForm(f => ({...f, notes:e.target.value}))}
                placeholder="Customer details, preferences, follow-up notes..."
                rows="4"
                style={{width:'100%',background:'rgba(255,255,255,.07)',border:'1px solid rgba(255,255,255,.12)',color:'#fff',padding:'12px',borderRadius:'11px',fontSize:'14px',fontFamily:'inherit',resize:'vertical'}}
              />
            </div>
            <button type="submit" className="btn-primary">
              {isEditing ? 'Save Changes' : 'Add Sale'}
            </button>
            {isEditing && (
              <button type="button" className="btn-secondary" style={{width:'100%',marginTop:'8px'}}
                onClick={() => { setShowAddSale(false); setEditingSaleId(null); setSaleForm({ customerName:'', vehicle:'', condition:'New', frontGross:0, backGross:0, spiffs:0, notes:'' }); }}>
                Cancel
              </button>
            )}
          </form>
        </div>
      </div>
    );
  }

  // ── Log Activity Modal ──
  if (showAddActivity) {
    return (
      <div className="modal-overlay" onClick={() => setShowAddActivity(false)}>
        <div className="modal-sheet" onClick={e=>e.stopPropagation()}>
          <div className="modal-hdr"><h3>Log Activity</h3><button className="modal-x" onClick={() => setShowAddActivity(false)}><X size={20}/></button></div>
          <form onSubmit={e => { e.preventDefault(); logTouch(activityForm.type, activityForm.customerName); setShowAddActivity(false); setActivityForm({ customerName:'', type:'Call' }); }} className="modal-form">
            <div className="form-group">
              <label>Customer Name</label>
              <input type="text" required value={activityForm.customerName} onChange={e=>setActivityForm(f=>({...f,customerName:e.target.value}))}/>
            </div>
            <div className="form-group">
              <label>Touch Type</label>
              <div className="type-btns">
                {['Call','Text','Email','Appointment'].map(t=>(
                  <button key={t} type="button"
                    className={`type-btn ${activityForm.type===t?'type-btn-active':''}`}
                    onClick={() => setActivityForm(f=>({...f,type:t}))}>
                    {t==='Call'?<Phone size={14}/>:t==='Text'?<MessageSquare size={14}/>:t==='Email'?<Mail size={14}/>:<Calendar size={14}/>}
                    {t}
                  </button>
                ))}
              </div>
            </div>
            <button type="submit" className="btn-primary">Log Activity</button>
          </form>
        </div>
      </div>
    );
  }

  return null;
}
